import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import Button from '@ontruck/ontruck-react-components/lib/Button';
import UserForm from '../UsersForm';
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@ontruck/ontruck-react-components/lib/Modal';
import { isValidOntruckEmail, isEmail } from 'utils/validators';
import { fetchSingleStaff, resetSingleStaff, clearCacheStaff } from 'redux/modules/staff/effects';
import { getSingleStaff } from 'redux/modules/staff/selectors';
import { getFilteredRoutes } from 'reselects/routes';

import { Formik } from 'formik';
import style from './style.module.scss';

class UserModalForm extends Component {
  componentDidMount() {
    const { id, fetchSingleStaff } = this.props;
    id && fetchSingleStaff(id);
  }

  validate = (values) => {
    const { intl } = this.props;

    const t = intl.messages.components.UsersModalForm;

    // TODO: yup schema, please!
    let errors = {};

    // email
    if (!values.email) {
      errors.email = intl.formatMessage(
        {
          id: 'UsersModalForm.errors.required',
          defaultMessage: '{field} must be defined',
        },
        { field: t.errors.email }
      );
    } else if (!isEmail(values.email)) {
      errors.email = t.errors.invalid_email;
    } else if (!isValidOntruckEmail(values.email)) {
      errors.email = t.errors.ontruck_email;
    }

    // role
    if (!values.group) {
      errors.group = intl.formatMessage(
        {
          id: 'UsersModalForm.errors.required',
          defaultMessage: '{field} must be defined',
        },
        { field: t.errors.role }
      );
    }

    //routes
    if (values.group && values.group !== 'ProdTech' && !values.routes.length) {
      errors.routes = intl.formatMessage(
        {
          id: 'UsersModalForm.errors.required',
          defaultMessage: '{field} must be defined',
        },
        { field: t.errors.routes }
      );
    }
    return errors;
  };

  onClose = () => {
    this.props.resetSingleStaff();
  };

  render() {
    const { show, close, onSend, staff, initialValues, id, routes, intl, me, clearCacheStaff } =
      this.props;

    const t = intl.messages.components.UsersModalForm;
    return (
      <Modal show={show} size="L" allowClose={false} onClose={this.onClose}>
        <div className={style.scrollableContainer}>
          <Formik
            onSubmit={onSend}
            enableReinitialize={true}
            initialValues={staff || initialValues}
            validate={this.validate}
            render={({ handleSubmit, ...formikProps }) => (
              <form className={style.form} onSubmit={handleSubmit}>
                <ModalHeader>{t.titles[id ? 'edit_user' : 'add_user']}</ModalHeader>
                <ModalBody light>
                  <UserForm
                    {...formikProps}
                    editing={!!id}
                    routes={routes}
                    userId={id}
                    me={me}
                    clearCacheStaff={clearCacheStaff}
                  />
                </ModalBody>
                {formikProps.dirty && (formikProps.errors.group || formikProps.errors.route) && (
                  <div className={style.errors}>
                    {formikProps.errors.group || formikProps.errors.route}
                  </div>
                )}
                <ModalFooter light>
                  <div className={style.actionsContainer}>
                    <Button className={style.btn} type="button" neutral onClick={close}>
                      {t.actions.cancel}
                    </Button>
                    <Button className={style.btn} type="submit">
                      {!!id ? t.actions.ok_save : t.actions.ok_add}
                    </Button>
                  </div>
                </ModalFooter>
              </form>
            )}
          />
        </div>
      </Modal>
    );
  }
}

UserModalForm.propTypes = {
  show: PropTypes.bool.isRequired,
  onSend: PropTypes.func.isRequired,
  fetchSingleStaff: PropTypes.func.isRequired,
  resetSingleStaff: PropTypes.func.isRequired,
  clearCacheStaff: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  staff: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string.isRequired,
    group: PropTypes.string,
  }),
  initialValues: PropTypes.shape({
    email: PropTypes.string.isRequired,
    group: PropTypes.string,
  }),
  id: PropTypes.string,
  loading: PropTypes.bool,
  sending: PropTypes.bool,
  routes: PropTypes.array,
  intl: PropTypes.object.isRequired,
  me: PropTypes.object,
};

UserModalForm.defaultProps = {
  initialValues: {
    first_name: '',
    last_name: '',
    email: '',
    group: '',
    routes: [],
  },
};

const mapStateToProps = (state) => ({
  routes: getFilteredRoutes(state, () => true),
  staff: getSingleStaff(state),
  loading: state.staff.single.fetching,
  sending: state.staff.pushing,
  me: state.me,
});

const mapDispatchToProps = {
  fetchSingleStaff,
  resetSingleStaff,
  clearCacheStaff,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(UserModalForm));
